export const handleInputChange = (
  e,
  setForm,
  Inputs,
  setErrors,
  form,
  setImageLogoLocal,
  setImageArticuloLocal
) => {
  const { name, value, files } = e.target;

  if (files && files.length > 0) {
    const selectedFile = files[0];
    const validTypes = ['image/jpeg', 'image/png'];

    if ((name === 'imagen_sitio' || name === 'imagen_articulo') && !validTypes.includes(selectedFile.type)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: 'Solo se aceptan archivos JPG o PNG',
      }));
      return;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    }

    // Manejo de vistas previas para imágenes
    if (name === 'imagen_sitio') {
      setImageLogoLocal((prevUrl) => {
        if (prevUrl && prevUrl.startsWith('blob:')) URL.revokeObjectURL(prevUrl);
        return URL.createObjectURL(selectedFile);
      });
    } else if (name === 'imagen_articulo') {
      setImageArticuloLocal((prevUrl) => {
        if (prevUrl && prevUrl.startsWith('blob:')) URL.revokeObjectURL(prevUrl);
        return URL.createObjectURL(selectedFile);
      });
    }

    // Actualiza el formulario con el archivo
    setForm((prevForm) => ({
      ...prevForm,
      [name]: selectedFile,
    }));

  } else {
    let inputValue = value;

    // Actualiza el formulario con el valor normal
    setForm((prevForm) => ({
      ...prevForm,
      [name]: inputValue,
    }));

    // Validación personalizada para pcia_id
    if (name === 'pcia_id' && (!inputValue || inputValue === '0')) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: 'Debe seleccionar una provincia',
      }));
      return;
    }

    // Validación general desde Inputs (si existe)
    const inputConfig = Inputs.find((input) => input.name === name);
    if (inputConfig && inputConfig.validation) {
      const error = inputConfig.validation(inputValue, { ...form, [name]: inputValue });
      setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    }
  }
};
